const GET_AFFILIATE_USAGE_TOTAL_VISIT_STARTED = 'GET_AFFILIATE_USAGE_TOTAL_VISIT_STARTED';
const GET_AFFILIATE_USAGE_TOTAL_VISIT_SUCCESS = 'GET_AFFILIATE_USAGE_TOTAL_VISIT_SUCCESS';
const GET_AFFILIATE_USAGE_TOTAL_VISIT_FAIL = 'GET_AFFILIATE_USAGE_TOTAL_VISIT_FAIL';

const GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_STARTED = 'GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_STARTED';
const GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_SUCCESS = 'GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_SUCCESS';
const GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_FAIL = 'GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_FAIL';

const GET_AFFILIATE_CHART_DATA_STARTED = 'GET_AFFILIATE_CHART_DATA_STARTED';
const GET_AFFILIATE_CHART_DATA_SUCCESS = 'GET_AFFILIATE_CHART_DATA_SUCCESS';
const GET_AFFILIATE_CHART_DATA_FAIL = 'GET_AFFILIATE_CHART_DATA_FAIL';

const GET_AFFILIATE_TABLE_DATA_STARTED = 'GET_AFFILIATE_TABLE_DATA_STARTED';
const GET_AFFILIATE_TABLE_DATA_SUCCESS = 'GET_AFFILIATE_TABLE_DATA_SUCCESS';
const GET_AFFILIATE_TABLE_DATA_FAIL = 'GET_AFFILIATE_TABLE_DATA_FAIL';

const getAffiliateUsageTotalVisit = (history) => {
	return {
		type: GET_AFFILIATE_USAGE_TOTAL_VISIT_STARTED,
		history,
	};
};
const getAffiliateUsageTotalVisitSuccess = (visitCount = 0) => {
	return {
		type: GET_AFFILIATE_USAGE_TOTAL_VISIT_SUCCESS,
		visitCount,
	};
};
const getAffiliateUsageTotalVisitFail = () => {
	return {
		type: GET_AFFILIATE_USAGE_TOTAL_VISIT_FAIL,
	};
};

const getAffiliateUsageAverageTotalVisit = () => {
	return {
		type: GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_STARTED,
	};
};
const getAffiliateUsageAverageTotalVisitSuccess = (visitCount = 0) => {
	return {
		type: GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_SUCCESS,
		visitCount,
	};
};
const getAffiliateUsageAverageTotalVisitFail = () => {
	return {
		type: GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_FAIL,
	};
};

const getAffiliateUsageChartdata = (request, chartType) => {
	return {
		type: GET_AFFILIATE_CHART_DATA_STARTED,
		request,
		chartType,
	};
};
const getAffiliateUsageChartdataSuccess = (response = [], affiliateUsageDropdown) => {
	return {
		type: GET_AFFILIATE_CHART_DATA_SUCCESS,
		response,
		affiliateUsageDropdown,
	};
};
const getAffiliateUsageChartdataFail = () => {
	return {
		type: GET_AFFILIATE_CHART_DATA_FAIL,
	};
};

const getAffiliateUsageTabledata = (request) => {
	return {
		type: GET_AFFILIATE_TABLE_DATA_STARTED,
		request,
	};
};
const getAffiliateUsageTabledataSuccess = (response = []) => {
	return {
		type: GET_AFFILIATE_TABLE_DATA_SUCCESS,
		response,
	};
};
const getAffiliateUsageTabledataFail = () => {
	return {
		type: GET_AFFILIATE_TABLE_DATA_FAIL,
	};
};

export default {
	types: {
		GET_AFFILIATE_USAGE_TOTAL_VISIT_STARTED,
		GET_AFFILIATE_USAGE_TOTAL_VISIT_SUCCESS,
		GET_AFFILIATE_USAGE_TOTAL_VISIT_FAIL,
		GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_STARTED,
		GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_SUCCESS,
		GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_FAIL,
		GET_AFFILIATE_CHART_DATA_STARTED,
		GET_AFFILIATE_CHART_DATA_SUCCESS,
		GET_AFFILIATE_CHART_DATA_FAIL,
		GET_AFFILIATE_TABLE_DATA_STARTED,
		GET_AFFILIATE_TABLE_DATA_SUCCESS,
		GET_AFFILIATE_TABLE_DATA_FAIL,
	},
	creators: {
		getAffiliateUsageTotalVisit,
		getAffiliateUsageTotalVisitSuccess,
		getAffiliateUsageTotalVisitFail,
		getAffiliateUsageAverageTotalVisit,
		getAffiliateUsageAverageTotalVisitSuccess,
		getAffiliateUsageAverageTotalVisitFail,
		getAffiliateUsageChartdata,
		getAffiliateUsageChartdataSuccess,
		getAffiliateUsageChartdataFail,
		getAffiliateUsageTabledata,
		getAffiliateUsageTabledataSuccess,
		getAffiliateUsageTabledataFail,
	},
};
